import { useEffect, useState } from 'react';
import Inquiry from './Inquiry';

export default function ContactPopup() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const timer = window.setTimeout(() => setIsOpen(true), 5000);
        return () => window.clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!isOpen) return undefined;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const closeOnEscape = (event) => {
            if (event.key === 'Escape') setIsOpen(false);
        };

        document.addEventListener('keydown', closeOnEscape);
        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', closeOnEscape);
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="contact-popup-overlay" role="presentation" onMouseDown={() => setIsOpen(false)}>
            <div className="contact-popup-dialog" role="dialog" aria-modal="true" aria-label="Contact Cloud Mind" onMouseDown={(event) => event.stopPropagation()}>
                <button className="contact-popup-close" type="button" onClick={() => setIsOpen(false)} aria-label="Close contact form">
                    <i className="fa fa-times" aria-hidden="true"></i>
                </button>
                <Inquiry />
            </div>
        </div>
    );
}
